<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        Strumenti
      </v-card-title>
      <v-card-text>
        <h3>Esporta eventi per anno</h3>
        <v-select v-model="exportYear" :items="years"></v-select>
        <v-btn
          v-translate
          depressed
          class="mr-4"
          color="primary"
          :loading="loading"
          @click="doExport"
        >
          Esporta
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      exportYear: 2020,
    }
  },
  computed: {
    years() {
      return this.range(2020, new Date().getFullYear() + 1).map((y) => ({
        value: y,
        text: y,
      }))
    },
  },
  methods: {
    range(start, end) {
      return Array.from({ length: end - start }, (v, k) => k + start)
    },
    doExport() {
      this.axios.post(`/events/export/${this.exportYear}/`).then((resp) => {
        const blob = new Blob([resp.data.data], { type: "text/csv" })
        const link = document.createElement("a")
        link.href = URL.createObjectURL(blob)
        link.download = `export${this.exportYear}`
        link.click()
        URL.revokeObjectURL(link.href)
      })
    },
  },
}
</script>
